// src/pages/AdminPanel/AdminPanel.jsx

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import ProductList from './ProductList';
import EditProduct from './EditProduct';
import AdminSidebar from '../../components/AdminItems/AdminSidebar/AdminSidebar';
import AddProduct from "../../pages/AdminPanel/AddProduct";
import './AdminPanel.css';
import Orders from './Orders';
import AnalyticsDashboard from './AnalyticsDashboard';
import Customers from './Customers';
import Settings from './Settings';

const AdminPanel = () => {
  return (
    <div className="admin-container">
      <AdminSidebar />
      <main className="admin-content">
        <Routes>
          <Route path="/" element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<ProductList />} />
          <Route path="products/add" element={<AddProduct />} />
          <Route path="edit/:id" element={<EditProduct />} />
          <Route path="products/edit/:productId" element={<EditProduct />} /> {/* Route for editing specific products */}
          {/* Add more admin routes here as you build them (e.g., orders, customers, settings) */}
          <Route path="*" element={<h1 className="text-xl">Admin Page Not Found</h1>} /> 
          <Route path="orders" element={<Orders />} />
          <Route path="analytics" element={<AnalyticsDashboard />} />
          <Route path="customers" element={<Customers />} />
          <Route path="settings" element={<Settings />} />
         
        </Routes>
      </main>
    </div>
  );
};

export default AdminPanel;